import { useMutation } from "react-query";
import axios from "../axios";
import qs from "query-string";

type DownloadLaporanParams = {
    ukmId?: number;
    tanggalAwal: string;
    tanggalAkhir: string;
    isInvoice?: number;
    isProduk?: number;
    isMutasi?: number;
    timezone: string;
};

const downloadLaporan = async (params: DownloadLaporanParams) => {
    const url = qs.stringifyUrl({
        url: "/api/downloadlaporan",
        query: { ...params },
    });
    const response = await axios.get<Blob>(url, { responseType: "blob" });
    return response.data;
};

export default function useDownloadLaporan() {
    return useMutation((params: DownloadLaporanParams) =>
        downloadLaporan(params),
    );
}
